interface UnitType {
  unit: string;
  pre: string;
  id?: string;
}

export const getUnitType = (
  unit: string | undefined,
  customUnits: UnitType[] | undefined,
): UnitType => {
  if (unit && UnitTypes[unit as keyof typeof UnitTypes]) {
    return UnitTypes[unit as keyof typeof UnitTypes];
  }
  if (customUnits && unit) {
    const customUnit = customUnits.find((item) => item.id === unit);
    if (customUnit) {
      return customUnit;
    }
  }
  return UnitTypes.DEFAULT;
};
export const UnitTypes = {
  DEFAULT: {
    unit: 'Styck',
    pre: 'st',
    id: 'APIECE',
  },
  APIECE: {
    unit: 'Styck',
    pre: 'st',
    id: 'APIECE',
  },
  KG: {
    unit: 'Kilogram',
    pre: 'kg',
    id: 'KG',
  },
  LITER: {
    unit: 'Liter',
    pre: 'l',
    id: 'LITER',
  },
  METER: {
    unit: 'Meter',
    pre: 'm',
    id: 'METER',
  },
  HOUR: {
    unit: 'Timmar',
    pre: 'h',
    id: 'HOUR',
  },
};
